import { connect } from "react-redux";
import Editar from "./ProductoEditar";
import { editar, actions } from "../../../../redux/modules/producto/producto";

const ms2p = (state) => {
    const { sucursales, es_admin, editar_precio } = state.usuario.me;
    const values = state.form.ProductoEditar
        ? state.form.ProductoEditar.values
        : {};
    let lista_sucursales = [];
    if (sucursales && values) {
        sucursales.forEach((sucursal) => {
            if (sucursal.id != "empresa") {
                const precios_sucursal = values.precios_sucursal
                    ? values.precios_sucursal
                    : [];
                const encontrado = _.find(precios_sucursal, function (o) {
                    return o.sucursal == sucursal.id;
                });
                if (!encontrado && values.tipo_producto != "100") {
                    lista_sucursales.push({
                        id: sucursal.id,
                        nombre: sucursal.nombre,
                    });
                }
            }
        });
    }

    return {
        ...state.producto,
        unidades_de_medida_empresa: state.usuario.unidades_de_medida_empresa,
        // unidades_medidas_seleccionadas: state.producto.unidades_medidas,
        conf_tienda_online: state.usuario.conf_tienda_online,
        lista_sucursales,
        nombres_precios: state.usuario.nombres_precios,
        conf_porcentaje_precio: state.usuario.conf_porcentaje_precio,
        conf_tipo_negocio:
            state.configuracion && state.configuracion.config
                ? state.configuracion.config.conf_tipo_negocio
                : "Normal", // Verificación añadida
        es_admin,
        editar_precio,
    };
};

const md2p = {
    submit: (fotos) => (dispatch) => dispatch(editar(fotos)),
    ...actions,
};

export default connect(ms2p, md2p)(Editar);
